import { Store } from './store';
import { getConfig, getContext } from '@wordpress/interactivity';

export const getScrolledPercent = () => {
	const height = document.documentElement;
	const body = document.body;
	const st = 'scrollTop';
	const sh = 'scrollHeight';

	return (
		( ( height[ st ] || body[ st ] ) /
			( ( height[ sh ] || body[ sh ] ) - height.clientHeight ) ) *
		100
	);
};

export const isAdBlocked = ( callback ) => {
	const url = `//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?=${ new Date().getTime() }`;
	fetch( url, { mode: 'no-cors', method: 'HEAD' } )
		.then( ( response ) => {
			callback( response.redirected ); // ads are blocked if request is redirected
		} ) // (we assume the REQUEST_URL doesn't use redirections)
		.catch( () => {
			callback( true ); // ads are blocked if request fails
		} );
};

export const emitEvent = ( eventName, data ) => {
	window.dispatchEvent(
		new CustomEvent( 'popper-' + eventName, { detail: data } )
	);
};

export const storeInCache = ( id ) => {
	const context = getContext();
	const { settings, triggers } = context;
	const store = new Store();
	store.set( 'Popper_' + id, 1 );

	if ( ! triggers.includes( 'dismissForVisitors' ) ) {
		return;
	}

	let expires = '';
	if ( settings.dismissForVisitors.period.endsWith( 'd' ) ) {
		expires = Number(
			settings.dismissForVisitors.period.replace( /\D/g, '' )
		);
	}
	if ( settings.dismissForVisitors.period.endsWith( 'h' ) ) {
		expires = new Date(
			new Date().getTime() +
				settings.dismissForVisitors.period.replace( /\D/g, '' ) *
					60 *
					60 *
					1000
		);
	}
	if ( settings.dismissForVisitors.period.endsWith( 'm' ) ) {
		expires = new Date(
			new Date().getTime() +
				settings.dismissForVisitors.period.replace( /\D/g, '' ) *
					60 *
					1000
		);
	}

	store.set( 'Popper_' + id, 1, { expires } );
};

export const canView = ( id ) => {
	const context = getContext();
	const { settings, triggers } = context;

	const store = new Store();

	if ( triggers.includes( 'pageviews' ) && settings.pageviews ) {
		const totalVisited = store.get( 'Popper_hits' );
		if ( totalVisited < settings.pageviews.pageNum ) {
			return false;
		}
		store.remove( 'Popper_hits' );
	}

	if (
		triggers.includes( 'dismissForVisitors' ) &&
		settings.dismissForVisitors
	) {
		const viewed = store.get( 'Popper_' + id );

		if ( viewed ) {
			return false;
		}
	}

	return true;
};

export const hitcounter = () => {
	const context = getContext();
	const { settings, triggers } = context;
	if ( ! triggers.includes( 'pageviews' ) ) {
		return;
	}
	const store = new Store();

	const total = store.get( 'Popper_hits', 1 );
	store.set( 'Popper_hits', total ? total + 1 : 1 );
	store.set( 'Popper_visited', window.location.href );

	return total >= settings.pageviews.pageNum;
};

export const checkDevice = () => {
	const context = getContext();
	const { devices } = context;

	if ( ! devices ) {
		return;
	}

	if (
		devices.includes( 'desktop' ) &&
		! context.isMobile &&
		! context.isTablet
	) {
		return true;
	}
	if ( devices.includes( 'tablet' ) && context.isTablet ) {
		return true;
	}
	if ( devices.includes( 'mobile' ) && context.isMobile ) {
		return true;
	}
};

export const isMobile = () => {
	return window.matchMedia( 'only screen and (max-width: 767px)' ).matches;
};

export const isTablet = () => {
	return window.matchMedia( '(min-width:768px) and (max-width: 992px)' )
		.matches;
};

export const closeVideos = ( elm ) => {
	const frames = elm.getElementsByTagName( 'iframe' );
	const videos = elm.getElementsByTagName( 'video' );
	const prestos = elm.getElementsByTagName( 'presto-player' );

	for ( const item of frames ) {
		const iframeSrc = item.src;
		item.src = '';
		item.src = iframeSrc;

		//item.contentWindow.location.reload( true );
		item.contentWindow.postMessage(
			'{"event":"command","func":"pauseVideo","args":""}',
			'*'
		);

		item.setAttribute( 'src', iframeSrc );
	}

	for ( const item of videos ) {
		item.pause();
	}

	for ( const item of prestos ) {
		item.pause();
	}
};
